import type { RouteRecordRaw } from "vue-router";
import FlowLayout from "@/views/layouts/flowLayout.vue";

const meRouters: RouteRecordRaw[] = [
    {
        path: "/me",
        name: "Me",
        meta: { title: "账号管理" },
        component: FlowLayout,
        redirect: "/me/info",
        children: [
            // 个人信息
            {
                path: "info",
                name: "Info",
                meta: { title: "个人信息" },
                component: () => import("@/views/pages/me/info/index.vue")
            },
            {
                path: "safeSetting",
                name: "SafeSetting",
                meta: { title: "安全设置" },
                component: () => import("@/views/pages/me/safeSetting/index.vue")
            },
            {
                path: "safeSetting/updatePassword",
                name: "UpdatePassword",
                meta: { title: "更新密码" },
                component: () => import("@/views/pages/me/safeSetting/updatePassword/index.vue")
            },
            {
                path: "safeSetting/updateEmail",
                name: "UpdateEmail",
                meta: { title: "更新邮箱" },
                component: () => import("@/views/pages/me/safeSetting/updateEmail/index.vue")
            },
            {
                path: "authentication",
                name: "Authentication",
                meta: { title: "认证" },
                component: () => import("@/views/pages/me/authentication/index.vue")
            },
            {
                path: "authentication/phone",
                name: "AuthenticationPhone",
                meta: { title: "换绑手机号认证" },
                component: () => import("@/views/pages/me/authenticationPhone/index.vue")
            },
            {
                path: "subAccountManagement",
                name: "SubAccountManagement",
                meta: { title: "子账号管理" },
                component: () => import("@/views/pages/me/subAccountManagement/index.vue")
            },
            {
                path: "subAccountManagement/detail",
                name: "SubAccountManagementDetail",
                meta: { title: "子账号信息" },
                component: () => import("@/views/pages/me/subAccountManagement/detail.vue")
            },
            {
                path: "subAccountManagement/edit",
                name: "SubAccountManagementEdit",
                meta: { title: "编辑子账号" },
                component: () => import("@/views/pages/me/subAccountManagement/edit.vue")
            },
            {
                path: "subAccountManagement/invitationHistory",
                name: "InvitationHistory",
                meta: { title: "邀请记录" },
                component: () => import("@/views/pages/me/subAccountManagement/invitationHistory/index.vue")
            },
            {
                path: "invitationRecord",
                name: "InvitationRecord",
                meta: { title: "受邀记录" },
                component: () => import("@/views/pages/me/invitationRecord/index.vue")
            },
            {
                path: "SMSManagement",
                name: "SMSManagement",
                meta: { title: "短信管理" },
                component: () => import("@/views/pages/me/SMSManagement/index.vue")
            },
            {
                path: "SMSManagement/edit",
                name: "SMSManagementEdit",
                meta: { title: "短信管理" },
                component: () => import("@/views/pages/me/SMSManagement/edit.vue")
            },
            {
                path: "invoice",
                name: "Invoice",
                meta: { title: "发票抬头" },
                component: () => import("@/views/pages/me/invoice/index.vue")
            },
            {
                path: "invoice/add",
                name: "InvoiceAdd",
                meta: { title: "新增发票抬头" },
                component: () => import("@/views/pages/me/invoice/add.vue")
            },
            {
                path: "address",
                name: "Address",
                meta: { title: "我的地址" },
                component: () => import("@/views/pages/me/address/index.vue")
            },
            {
                path: "address/add",
                name: "AddressAdd",
                meta: { title: "新增地址" },
                component: () => import("@/views/pages/me/address/add.vue")
            },
            {
                path: "bankAccount",
                name: "BankAccount",
                meta: { title: "银行账户" },
                component: () => import("@/views/pages/me/bankAccount/index.vue")
            },
            {
                path: "bankAccount/edit",
                name: "BankAccountAdd",
                meta: { title: "编辑银行账户" },
                component: () => import("@/views/pages/me/bankAccount/edit/index.vue")
            }
        ]
    },
    {
        path: "/me/member",
        meta: { title: "我的会员" },
        component: FlowLayout,
        children: [
            {
                path: "",
                name: "Member",
                meta: { title: "我的会员" },
                component: () => import("@/views/pages/me/member/index.vue")
            }
        ]
    }
];

export default meRouters;
